


export const initUserMedia = (constraints) => {

  var defaultConstraints = {
    audio: true,
    video: true,
  };

  return navigator.mediaDevices
    .getUserMedia(constraints || defaultConstraints)
    .catch(onUserMediaError);

}

const onUserMediaError = (error) => {

  console.log("ERROR", `getUserMedia error: ${error.name}`, error);
}


export const getVideoElementDetails = (id) => {

  const videoElement = document.getElementById(id);

  return {
    videoElement,
    rect: videoElement.getBoundingClientRect()
  }

}


// WEBPACK FOOTER //
// ./src/Components/JitsuCamponent/user-media.js